import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitoaurangabadcab() {



  const cardData = {
    keyword: " Mumbai to Aurangabad Cab ",

"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Aurangabad cab services, ensuring a safe, smooth, and hassle-free journey for families, tourists, business travelers, and group trips. Whether you are planning a heritage tour, Ajanta Ellora caves visit, or a weekend getaway, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Aurangabad route covers approximately 330 to 350 km and takes around 6 to 7 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized travel packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Aurangabad travel.",

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "Ajanta Caves are a UNESCO World Heritage Site famous for ancient Buddhist rock-cut caves, paintings, and sculptures. These caves showcase India’s rich cultural and artistic heritage and attract history lovers and tourists from around the world."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves are one of the largest rock-cut temple cave complexes in the world, featuring Hindu, Buddhist, and Jain monuments. The Kailasa Temple is the most famous highlight, carved entirely from a single rock."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Bibi Ka Maqbara is often called the 'Taj of the Deccan' due to its resemblance to the Taj Mahal. It is a beautiful Mughal-era monument built in memory of Dilras Banu Begum."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort is a massive and strategically built hill fort known for its strong defense system, dark tunnels, and panoramic views of the surrounding region."
  },
  {
    "title": "Grishneshwar Temple",
    "description": "Grishneshwar Temple is one of the twelve Jyotirlingas dedicated to Lord Shiva, located near Ellora Caves. It is an important pilgrimage site for devotees."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves are ancient rock-cut Buddhist caves located on a hill, known for their intricate carvings and peaceful surroundings."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki is a historic water mill built in the Mughal era, famous for its engineering marvel and serene garden surroundings."
  },
  {
    "title": "Siddharth Garden and Zoo",
    "description": "Siddharth Garden and Zoo is a popular family attraction in Aurangabad featuring a zoo, aquarium, and lush green gardens for relaxation."
  },
  {
    "title": "Soneri Mahal",
    "description": "Soneri Mahal is a historic palace now converted into a museum showcasing artifacts, sculptures, and cultural heritage of the region."
  },
  {
    "title": "Gautala Autramghat Sanctuary",
    "description": "Gautala Autramghat Sanctuary is a natural wildlife area near Aurangabad known for its forests, biodiversity, and scenic landscapes ideal for nature lovers."
  }
],







services: [
  {
    name: "Mumbai to Aurangabad Cab",
    description: "Mumbai to Aurangabad cab service offers a comfortable and reliable journey to one of Maharashtra’s historic and industrial cities, also known as Sambhajinagar. The route is ideal for tourists visiting Ajanta Ellora caves, business travelers, and family trips. Professional drivers ensure safe highway travel and timely arrival. Customers can choose from sedan, SUV, and luxury vehicles. Flexible pickup across Mumbai adds convenience. It ensures a smooth and hassle-free travel experience."
  },
  {
    name: "Aurangabad to Mumbai One Way Taxi",
    description: "Aurangabad to Mumbai one way taxi is a cost-effective option for travelers needing a single-side drop without return charges. This service is ideal for business travel, relocation, or airport transfers. Comfortable vehicles and experienced drivers ensure safe journeys. Flexible pickup timings add convenience. It is perfect for economical long-distance travel."
  },
  {
    name: "Aurangabad to Mumbai Taxi",
    description: "Aurangabad to Mumbai taxi provides reliable and comfortable transportation with door-to-door service. This service is suitable for families, tourists, and corporate travelers. Clean vehicles and trained drivers ensure a safe journey. Flexible travel schedules enhance convenience. It guarantees a stress-free travel experience."
  },
  {
    name: "One Way Cab Mumbai to Aurangabad",
    description: "One way cab Mumbai to Aurangabad is a budget-friendly travel option for passengers planning a single journey. This service eliminates return fare costs and provides flexible pickup options. Ideal for tourists and business travelers. Professional drivers ensure safe and timely travel. It ensures a smooth and economical journey."
  },
  {
    name: "Mumbai to Aurangabad Taxi Fare",
    description: "Mumbai to Aurangabad taxi fare is structured to provide transparent and competitive pricing. Fare depends on vehicle type, trip duration, and travel plan. Customers receive clear cost breakdowns with no hidden charges. Budget and premium options are available. It helps travelers plan their journey efficiently."
  },
  {
    name: "Mumbai to Aurangabad Taxi",
    description: "Mumbai to Aurangabad taxi offers convenient and private travel for long-distance journeys. This service is ideal for tourists, corporate clients, and family trips. Vehicles are well-maintained and driven by experienced chauffeurs. Door-to-door pickup and drop enhance comfort. It ensures a reliable and smooth travel experience."
  },
  {
    name: "Mumbai to Aurangabad One Way Taxi",
    description: "Mumbai to Aurangabad one way taxi is ideal for travelers who need a single-side journey. This service offers affordable pricing without return charges. Flexible travel timings and comfortable vehicles add convenience. Professional drivers ensure safe highway travel. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Aurangabad Car Rental",
    description: "Mumbai to Aurangabad car rental provides flexible travel solutions for personal and business needs. Customers can choose from a wide range of vehicles based on their comfort and group size. Suitable for one-way and round trips. Easy booking and transparent pricing enhance convenience. It ensures a comfortable journey."
  },
  {
    name: "Mumbai to Aurangabad Cab Booking",
    description: "Mumbai to Aurangabad cab booking allows customers to reserve their ride quickly and easily. Travelers can select vehicle type, pickup location, and travel date as per their preference. Instant confirmation and transparent pricing make the process simple. It ensures a hassle-free booking experience."
  },
  {
    name: "Mumbai Aurangabad Taxi Service",
    description: "Mumbai Aurangabad taxi service offers dependable intercity transportation with a focus on comfort and safety. This service is suitable for tourists visiting heritage sites and business travelers. Vehicles are well-maintained for long-distance travel. Professional drivers ensure smooth journeys. It guarantees reliable service."
  },
  {
    name: "Mumbai Airport to Aurangabad Taxi",
    description: "Mumbai airport to Aurangabad taxi provides direct pickup for passengers arriving in Mumbai and heading to Aurangabad. This service ensures timely pickups and smooth highway travel. Comfortable vehicles and experienced drivers enhance the journey. It is perfect for seamless airport transfers."
  },
  {
    name: "Mumbai to Sambhajinagar Cab",
    description: "Mumbai to Sambhajinagar cab service connects travelers to Aurangabad with reliable and comfortable transport. Ideal for tourism, industrial visits, and family travel. Vehicles are maintained for long routes. Flexible pickup options enhance convenience. It ensures a smooth travel experience."
  },
  {
    name: "Navi Mumbai to Aurangabad Cab",
    description: "Navi Mumbai to Aurangabad cab offers convenient pickup from Navi Mumbai areas with direct travel to Aurangabad. This service is ideal for residential and corporate travelers. Comfortable vehicles and professional drivers ensure safe travel. It provides a reliable journey."
  },
  {
    name: "Thane to Aurangabad Cab",
    description: "Thane to Aurangabad cab service provides easy and comfortable travel for residents of Thane. This service ensures direct pickup and smooth highway travel. Suitable for family trips, business travel, and tourism. Experienced drivers ensure safe journeys. It guarantees convenience and comfort."
  },
  {
    name: "Mumbai to Ajanta Ellora Tour Package",
    description: "Mumbai to Ajanta Ellora tour package offers a complete travel experience for visitors exploring UNESCO heritage caves. This package includes cab service, flexible travel plans, and comfortable vehicles. Ideal for tourists and family trips. Professional drivers ensure safe travel. It provides a well-planned and memorable tour."
  },
  {
    name: "Mumbai to Paithan Cab Service",
    description: "Mumbai to Paithan cab service is ideal for travelers visiting the historic town of Paithan near Aurangabad. This service ensures comfortable long-distance travel with experienced drivers. Suitable for pilgrims and tourists. Flexible pickup options enhance convenience. It ensures a smooth journey."
  },
  {
    name: "Mumbai to Aurangabad MIDC",
    description: "Mumbai to Aurangabad MIDC cab service is designed for corporate and industrial travel needs. This service is ideal for business visits, employee transport, and client meetings. Professional drivers and well-maintained vehicles ensure punctuality and reliability. It provides efficient corporate travel solutions."
  }
],

tableData: [
  ["Mumbai to Aurangabad Cab", "Aurangabad to Mumbai One Way Taxi"],
  ["Aurangabad to Mumbai Taxi", "One Way Cab Mumbai to Aurangabad"],
  ["Mumbai to Aurangabad Taxi Fare", "Mumbai to Aurangabad Taxi"],
  ["Mumbai to Aurangabad One Way Taxi", "Mumbai to Aurangabad Car Rental"],
  ["Mumbai to Aurangabad Cab Booking", "Mumbai Aurangabad Taxi Service"],
  ["Mumbai Airport to Aurangabad Taxi", "Mumbai to Sambhajinagar Cab"],
  ["Navi Mumbai to Aurangabad Cab", "Thane to Aurangabad Cab"],
  ["Mumbai to Ajanta Ellora Tour Package", "Mumbai to Paithan Cab Service"],
  ["Mumbai to Aurangabad MIDC", "Mumbai to Aurangabad Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Aurangabad Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Aurangabad cab service, ideal for family trips, business travel, and heritage tours."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Aurangabad routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Aurangabad cab service operates 24/7, allowing flexible travel for day or night journeys."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day Aurangabad travel packages."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, luxury vehicles, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Aurangabad cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Aurangabad cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Aurangabad for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Aurangabad?", answer: "The distance is approximately 330 to 360 km and takes around 6 to 8 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Aurangabad cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, luxury cars, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, airport, and office anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak travel seasons." },
  { question: "Can I visit Ajanta and Ellora caves during the trip?", answer: "Yes, we offer customizable travel plans including Ajanta and Ellora sightseeing." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Swapnil Jadhav",
    feedback: "The Mumbai to Aurangabad cab service with Royal Route Cabs was very smooth and comfortable. The driver was punctual and ensured a safe highway journey throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "Excellent experience traveling from Mumbai to Aurangabad. The cab was clean, the ride was comfortable, and the service felt reliable and well-managed.",
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Aurangabad Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-aurangabad-cab.jpg", // replace if needed
  "description": "Book Mumbai to Aurangabad cab with Royal Route Cabs for a safe, comfortable, and affordable journey. Available one-way and round-trip taxi services with sedan, SUV, Innova, and luxury cars. Trusted drivers and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-aurangabad-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Aurangabad Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Aurangabad cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to aurangabad cab, aurangabad to mumbai one way taxi, aurangabad to mumbai taxi, one way cab mumbai to aurangabad, mumbai to aurangabad taxi fare, mumbai to aurangabad taxi, mumbai to aurangabad one way taxi, mumbai to aurangabad car rental, mumbai to aurangabad cab booking, mumbai aurangabad taxi service, mumbai airport to aurangabad taxi, mumbai to sambhajinagar cab, mumbai to aurangabad taxi fare, mumbai to aurangabad taxi fare per day, navi mumbai to aurangabad cab, thane to aurangabad cab, mumbai to ajanta ellora tour package, mumbai to paithan cab service, mumbai to aurangabad MIDC"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoaurangabadcab;